<div [ngClass]="{'data-row-bottom-border': bottomBorder, 'data-row': !bottomBorder}" data-testid="data-row-bottom-border">
    <div class="data-column">
        <label>{{title}}</label>
    </div>
    <div *ngIf="data" class="data-column value" data-testid="data_condensed-label-top-section">{{data}}</div>
    <div *ngIf="multilineData" class="data-column" data-testid="multilineData_condensed-label-top-section">
        <div *ngFor="let line of multilineData" class="value">{{line}}</div>
    </div>
</div>